import React, { useState } from "react";
import { Send } from "lucide-react";
import useFetch from "@/lib/useFetch";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Footer } from "@/components/common/Page";
import Loader from "@/components/common/Loader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { timeAgo } from "@/lib/communities";

export default function Messages() {
    const { user } = useAuth();
    const { data: communities } = useFetch("/communities");
    const [channel, setChannel] = useState("CODERS_PLAYGROUND");
    const { data: msgs, reload } = useFetch(`/messages?community_key=${channel}`, [channel]);
    const [text, setText] = useState("");
    if (!communities) return <Loader />;

    const send = async () => {
        if (!text.trim()) return;
        await api.post("/messages", { community_key: channel, body: text });
        setText(""); reload();
    };

    return (
        <div data-testid="player-messages">
            <PageHeader title="Messages" subtitle="Community squad board. Chat with your fellow survivors." />
            <div className="tactical-card rounded-lg flex flex-col h-[62vh]">
                <div className="flex items-center gap-2 border-b border-border p-3">
                    <span className="label-mono text-muted-foreground">CHANNEL</span>
                    <Select value={channel} onValueChange={setChannel}>
                        <SelectTrigger data-testid="message-channel" className="w-56 bg-background border-border h-8"><SelectValue /></SelectTrigger>
                        <SelectContent>{communities.map((c) => <SelectItem key={c.key} value={c.key}>{c.name}</SelectItem>)}</SelectContent>
                    </Select>
                </div>
                <div className="flex-1 overflow-y-auto p-4 space-y-3">
                    {!msgs ? <Loader /> : msgs.length === 0 ? <div className="text-muted-foreground text-center mt-10">No messages yet. Start the conversation.</div> :
                        msgs.map((m) => {
                            const mine = m.user_email === user?.email;
                            return (
                                <div key={m.id} data-testid={`message-${m.id}`} className={`flex gap-2 ${mine ? "flex-row-reverse" : ""}`}>
                                    <img src={m.avatar || `https://api.dicebear.com/7.x/bottts/svg?seed=${m.username}`} className="h-8 w-8 rounded-md border border-border bg-background shrink-0" alt="" />
                                    <div className={`max-w-[75%] rounded-lg border p-2.5 ${mine ? "border-hazard/40 bg-hazard/10" : "border-border bg-background/40"}`}>
                                        <div className="flex items-center gap-2"><span className="font-heading font-semibold text-foreground text-sm">{m.username}</span><span className="label-mono text-muted-foreground">{timeAgo(m.created_at)}</span></div>
                                        <p className="text-sm text-foreground mt-0.5">{m.body}</p>
                                    </div>
                                </div>
                            );
                        })}
                </div>
                <div className="border-t border-border p-3 flex gap-2">
                    <Input data-testid="message-input" value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
                        placeholder="Type a message…" className="bg-background border-border" />
                    <Button data-testid="message-send" onClick={send} className="font-heading uppercase bg-hazard text-black hover:bg-hazard/90"><Send size={15} /></Button>
                </div>
            </div>
            <Footer />
        </div>
    );
}
